import React from 'react'
import { useNavigate } from 'react-router-dom'

const Slider = () => {
  const nav= useNavigate();
  
  return (
    <div className='bg-black flex flex-col lg:flex-row justify-between'>
        <div className='text-white w-full lg:w-1/2 flex flex-col justify-center p-4 lg:p-8'>
          <div className='text-2xl lg:text-4xl font-bold mb-2'>
            New Design, New You
          </div>
          <div className='text-base lg:text-md mb-4'>
            Step into uniqueness with custom kicks
          </div>
          <a className='bg-white text-black rounded-full px-4 lg:px-6 py-2 w-24 lg:w-32 mx-auto' onClick={()=>nav("/products")}>
            Explore
          </a>
        </div>
        <div className='self-center lg:self-end w-3xl lg:w-1/2'>
          <img width ="100%" src={`https://res.cloudinary.com/custoshoe/image/upload/v1693513970/gptz9jflscerycsccvcs.jpg`} alt="Shoes" />
        </div>
    </div>

  )
}

export default Slider